import React from 'react'

export const Usuarios = () => {
  return (
    <div>Usuario</div>
  )
}
